{
	"title": "Декларации",
	"table": {
		"material": "Материал",
		"dateOfIssue": "Дата на издаване",
		"quantity": "Количество",
		"carbonSavings": "Въглеродни редукции",
		"status": {
			"title": "Статус",
			"TransactionProcessing": "Обработване на транзакцията",
			"CreatingDeclaration": "Създаване на декларация",
			"GenerationFailed": "Генерирането е неуспешно",
			"ReadyToDownload": "Готово за изтегляне"
		}
	},
	"declarationLanguageSelect": {
		"title": "Език на декларацията",
		"description": "Изберете език на декларацията.",
		"label": "Език на декларацията",
		"buttonBack": "Назад",
		"buttonSave": "Запази"
	},
	"downloadAllLanguageSelect": {
		"title": "Езици на декларациите",
		"descriptionGlobal": "Изберете език за всички декларации.",
		"descriptionIndividual": "Или задайте езика за всяка декларация поотделно.",
		"label": "Езици на декларациите",
		"tableHeaderDeclaration": "Декларация (материал/дата на издаване)",
		"tableHeaderLanguage": "Език на декларацията",
		"buttonBack": "Назад",
		"buttonDownload": "Изтегли декларации"
	},
	"declarationActions": {
		"changeLanguage": "Промени езика на декларацията",
		"preview": "Преглед",
		"download": "Изтегли",
		"transaction": "Транзакция",
		"showMoreTransactions": "Покажи повече транзакции",
		"languageLabel": "Език на декларацията",
		"downloadAll": "Изтегли всички декларации"
	}
}
